/* RESPONSIBLE TEAM: team-standalone */

import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type RouterService from '@ember/routing/router-service';
import { ReactRoute } from 'embercom/lib/react-route';

class ErrorLogsIndexRoute extends Route {
  @service declare appService: {
    app: { hasStandalonePlatform: (platform: string) => boolean };
  };
  @service declare finStandaloneService: FinStandaloneService;
  @service declare router: RouterService;

  async beforeModel() {
    if (!this.appService.app.hasStandalonePlatform('salesforce')) {
      this.router.transitionTo('apps.app.settings');
      return;
    }
  }

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(ErrorLogsIndexRoute);
